// @flow
import { call, put, takeEvery } from 'redux-saga/effects';

import { alerts } from '~/core/constants';
import { homes as api } from '~/core/api';
import { requestAlert } from '~/core/state/alerts/actions';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';

import { getHomes, receiveHomes, renameHome, renamedHome } from './actions';
import messages from './intl';

import type { Effect } from 'redux-saga';
import type { RenameHomeAction } from './types';

export function* getHomesSaga(): Generator<Effect, *, *> {
    //API call here. Mocked for now
    const response = {
        user: '3d2e1f61-e385-41a4-a069-863ecaaa4411',
        homes: [
            {
                id: '4948205f-01f4-4d06-a4bd-219ea8bdc5ca',
                name: 'Andrew Home',
                address: null,
                location: {
                    country: 'GB',
                    timeZone: 'Europe/London',
                    latitude: 553780480,
                    longitude: -34359728
                },
                primary: true,
                users: [],
                owner: true
            }
        ],
        entitlements: {
            hiveLive: false,
            propertyEntitlements: 1,
            userEntitlements: 1
        }
    };
    yield put(receiveHomes(response.homes));
}

export function* renameHomeSaga({ payload: { name, homeId, userId } }: RenameHomeAction): Generator<Effect, *, *> {
    const [home, error] = yield call(handleApi(api.renameHome), name, homeId, userId);

    if (error) {
        yield put(renameHome(error));
        yield put(requestAlert(messages.nameChangeError, alerts.types.ERROR));
        return;
    }

    yield put(renamedHome(home));
}

function* watchGetHomes(): Generator<Effect, *, *> {
    yield takeEvery(getHomes, handleSaga(getHomesSaga));
}

function* watchRenameHome(): Generator<Effect, *, *> {
    yield takeEvery(renameHome, handleSaga(renameHomeSaga));
}

export default [watchGetHomes, watchRenameHome];



// WEBPACK FOOTER //
// ./src/core/state/homes/sagas.js